import {ListResponse} from '@cervello/use-data';
import API, {Services} from 'adapters/rest';
import {
  ServicesType,
  ServicesTypeData,
  ServicesName,
  Skills,
} from '../../definitions/types/servicesTypes';
import {CancelTokenSource} from 'axios';
import {Group} from '../../../types/Groups';

export const getServicesTypes = (projectId: string, query = ''): any => {
  const url = `/${Services.THINGS}/v1/projects/${projectId}/serviceTypes?${query || ''}`;
  return API.get<ListResponse<ServicesType>>(url).then(response => {
    return response.data;
  });
};

export const deleteServicesType = (projectId: string, data: string[]): Promise<string> => {
  const url = `/${Services.THINGS}/v1/projects/${projectId}/serviceTypes`;
  return API.delete(url, {data}).then(response => response.data.message);
};

export const createServiceType = (projectId: string, data: ServicesTypeData) => {
  const url = `${Services.THINGS}/v1/projects/${projectId}/serviceTypes`;
  return API.post<{result: string}>(url, data).then(response => response.data);
};

export const updateServiceType = (
  projectId: string,
  id: string,
  data: ServicesTypeData,
): Promise<string> => {
  const url = `${Services.THINGS}/v1/projects/${projectId}/serviceTypes/${id}`;

  return API.put(url, data).then(response => response.data.message);
};

export const checkServiceTypeName = (
  projectId: string,
  data: ServicesName,
  source: CancelTokenSource,
) => {
  const url = `${Services.THINGS}/v1/projects/${projectId}/serviceType-name`;

  return API.post<{result: boolean}>(url, data, {cancelToken: source.token}).then(
    response => response,
  );
};

export const getSkills = (projectId: string, query = ''): Promise<ListResponse<Skills>> => {
  const url = `/${Services.THINGS}/v1/projects/${projectId}/skills${query || '?limit=70'}`;
  return API.get<ListResponse<Skills>>(url).then(response => response.data || []);
};
